export default function ConfigPanel({ senderId, setSenderId, clientName, setClientName, mnoOptions, handleSenderIdKeyUp, handleCheckboxChange, selectedMnos, baseUrl }) {
  return (
    <div>

      <div className="card bg-light p-3 rounded border mb-4">
        <div className="mb-3 text-start">
          <label className="form-label fw-semibold small">SENDER ID</label>
          <input 
            type="text" 
            className="form-control" 
            value={senderId} 
            onChange={(e) => setSenderId(e.target.value)} 
            onKeyUp={(e)=>{handleSenderIdKeyUp(e)}}
          />
        </div>
                <div className="mb-3 text-start">
          <label className="form-label fw-semibold small">Client Name</label>
          <input 
            type="text" 
            className="form-control" 
            value={clientName} 
            onChange={(e) => setClientName(e.target.value)} 
          />
        </div>

        <div className="text-start mb-2">
          <label className="form-label fw-semibold small">Mobile Network Operators</label>
        </div>
        <div className='text-align-left'>
          {mnoOptions.map((label,index)=>(
             <div className='form-check text-start' key={`option${index+1}`}>
              <input type="checkbox" className='form-check-input' value={label} checked={selectedMnos.includes(label)} onChange={handleCheckboxChange} id={`option${index+1}`} name={`option${index+1}`} />
              <label className='form-check-label' htmlFor={`option${index+1}`}>{label}</label>
             </div>
            ))}
        </div>
      </div>
    </div>
  );
}
